// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__B2Sph","title":"Images90_title__2ravU","images":"Images90_images__3IgfT"};